export default __webpack_public_path__ + "static/media/read.f28d7537.svg";